import {
  BackgroundImage,
  Box,
  Center,
  Image,
  Progress,
  Text,
} from '@mantine/core';
import type React from 'react';
import {
  REPORT_ANALYTICS_BACKGROUND,
  REPORT_ANALYTICS_LOGO,
} from '../../../../config/constants/img';
import {
  useLoadingProgress,
  useLoadingText,
} from '../../usecase/useLoadingProgress';

type Props = Record<string, never>;

export const LoadingBox: React.FC<Props> = () => {
  const {dots} = useLoadingText();
  const {progress} = useLoadingProgress(2000);
  return (
    <Box className=" w-full my-[-12px] flex justify-center items-center">
      <BackgroundImage
        src={REPORT_ANALYTICS_BACKGROUND}
        className="w-full h-[100vh] flex justify-center"
      >
        <Center maw={400} h="auto" mx="auto" className="flex-col">
          <Box className="mb-12">
            <Image src={REPORT_ANALYTICS_LOGO} alt="AI選考対策" width={200} />
          </Box>
          <Box className="w-[200px] flex flex-col items-center justify-center">
            <Progress
              size="sm"
              color="yellow"
              className="w-full mb-4"
              value={progress}
            />
            <Text
              className="text-white text-lg italic whitespace-nowrap"
              style={{fontFamily: 'Avenir'}}
            >
              Analyzing the data ...
            </Text>
            <Text className="text-white text-sm whitespace-nowrap">
              データ分析中{dots}
            </Text>
          </Box>
        </Center>
      </BackgroundImage>
    </Box>
  );
};
